module.exports = __webpack_public_path__ + "static/media/15-item-a.0584cf67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/15-item-a.jpg
// module id = 1199
// module chunks = 33